// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseApiServiceFactory instead of class inheritance

import { createBaseApiService, type IBaseApiService } from "@Front/Api/BaseApiServiceFactory";

interface UserInstance {
	login(uid: string): Promise<unknown>;
	verifyJwt(jwt: string): Promise<unknown>;
}

// Module-level singleton instance
let instance: UserInstance | null = null;
let baseApiInstance: IBaseApiService | null = null;

function createUser(): UserInstance {
	if (!baseApiInstance) {
		baseApiInstance = createBaseApiService();
	}

	const baseApi = baseApiInstance;
	const baseUrl = `${baseApi.getBaseUrl()}/idnot/user`;

	return {
		login: async (uid: string): Promise<unknown> => {
			const url = new URL(`${baseUrl}/login/${uid}`);
			try {
				return await baseApi.postRequest(url);
			} catch (err) {
				baseApi.onError(err);
				return Promise.reject(err);
			}
		},
		verifyJwt: async (jwt: string): Promise<unknown> => {
			const url = new URL(`${baseUrl}/verify-token/${jwt}`);
			try {
				return await baseApi.postRequest(url);
			} catch (err) {
				baseApi.onError(err);
				return Promise.reject(err);
			}
		},
	};
}

export function getUserInstance(): UserInstance {
	if (!instance) {
		instance = createUser();
	}
	return instance;
}
